import MultiDictClient from '@mo-platform/multidict'

let dict = new MultiDictClient()

export default {
  async getLanguages() {
    
    return await (await fetch(`${process.env.VUE_APP_DICT_URL}/languages`)).json()
  },

  async getPhrases(phrase, lang, trans, bookSource) {
    let phrases = []
    dict.bookTitle = bookSource
    await dict.search(phrase, lang, trans)
      .then(function(data) {
        phrases = data.data
      })
    
    return phrases
  }
}